<template>
  <v-item-group
    mandatory
    active-class="chip-radio-active"
    :value="value"
    class="d-flex justify-space-around chip-radio-group"
    @change="$emit('input', $event)"
  >
    <v-item v-for="option in mappedOptions" :key="option.label" :value="option.value" v-slot="{ active, toggle }">
      <v-chip
        class="chip-radio-item"
        active-class="chip-radio-active"
        :input-value="active"
        small
        tabindex="0"
        @click="toggle"
        @keyup.enter="toggle"
        @change="$emit('change', $event)"
        @checked="$emit('checked', $event)"
        @input="$emit('input', $event)"
      >
        {{ option.label }}
      </v-chip>
    </v-item>
  </v-item-group>
</template>

<script>
export default {
  name: "chip-radio",

  props: {
    /**
     * Accepts either an array of strings or objects with a 'label' and 'value' pair
     */
    options: Array,
    value: String, // any
  },

  computed: {
    mappedOptions() {
      return this.options.map((option) => {
        if (typeof option == "string") {
          return { label: option, value: option };
        } else if (typeof option == "object") {
          if (typeof option.label != "string") throw Error("An option's 'label' must be a string");
          if (option.value == undefined) throw Error("An option's 'value' field must be defined if it's an object");
          return option;
        } else {
          throw Error("Invalid type for one or more options");
        }
      });
    },
  },
};
</script>

<style scoped>
.chip-radio-group {
  gap: 8px;
}

.chip-radio-item {
  color: white !important;
  background-color: var(--semi-opaque-overlay-bg-color) !important;
  width: 100px;
  font-size: 16px !important;
  justify-content: center;
}
.chip-radio-active,
.chip-radio-active:before {
  background-color: black !important;
  text-decoration: underline;
}
.chip-radio-item:focus-visible {
  transform: scale(1.2);
  border: 3px solid var(--v-primary-base);
}
</style>
